import { Component, Inject } from '@angular/core';
import { DigisubservicesService } from '../services/digisubservices.service';
import { AddBookPerPriceComponent } from '../pages/add-book-per-price/add-book-per-price.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-add-book-per-commision-price',
  templateUrl: './add-book-per-commision-price.component.html',
  styleUrl: './add-book-per-commision-price.component.scss'
})
export class AddBookPerCommisionPriceComponent {

  bookCommreceipt;
  bookCommdata = [];
  updatedCommBooks = [];
  initial_total_val: number = 0;
  crdtvAmt = 0;
  selectedAmt = 0;
  balanceAmt = 0;
  bal = 0;
  // bname:any;

  constructor(
    public service: DigisubservicesService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddBookPerPriceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  ngOnInit(): void {
    debugger;
    this.bookCommreceipt = this.data['book'];

    this.crdtvAmt = isNaN(this.data['crdtAAmt']) ? 0 : this.data['crdtAAmt'];
    this.selectedAmt = isNaN(this.data['seAAmt']) ? 0 : this.data['seAAmt'];
    this.balanceAmt = isNaN(this.data['balAAmt']) ? 0 : this.data['balAAmt'];
    this.bal = isNaN(this.data['bal']) ? 0 : this.data['bal'];
    // this.bname = this.data?.['bookName'] ?? '';

    // console.log(this.bname);
    console.log('rcpt data', this.bookCommreceipt);

    const fetchBooks = this.service.getRcptCommWiseBooks(this.bookCommreceipt['order_no']);

    fetchBooks.subscribe((data) => {
      console.log({ data });

      data.forEach((book) => {
        const total_amount = parseInt(book['total']) + parseInt(book['shipping_charges']);
        const rcvd_amt = parseInt(book['comm_rcvd_amt']) || 0;
        const remaining_amt: number = parseInt(book['rep_commission_amt']) - rcvd_amt;

        this.total_val += rcvd_amt;
        this.total_remaining_amt += remaining_amt;

        this.bookCommdata.push({
          id: this.bookCommreceipt['id'],
          bookid: book['bd_id'],
          book_name: book['book_name'],
          book_price: book['book_price'],
          book_copies: book['book_copies'],
          total: book['total'],
          shipping_charges: book['shipping_charges'],
          rep_name: book['rep_name'],
          office_rep_name: book['office_rep_name'],
          total_amount: total_amount,
          inv_received_amt: book['inv_received_amt'],
          rep_commission_amt: book['rep_commission_amt'],
          comm_remaining_amt: book['comm_remaining_amt'],
          rep_pincode: book['rep_pincode'],
          rep_district: book['rep_district'],
          rep_taluka: book['rep_taluka'],
          rep_mobile_no: book['rep_mobile_no'],
          commper: book['commper'],
          rcvd_amt: rcvd_amt,
          remaining_amt: remaining_amt,
          invoice_no: this.bookCommreceipt['invoice_no'],
          isDisabled: remaining_amt === 0 || remaining_amt === 0.00,
          order_no: book['order_no']
        });
      });
      console.log("==============================================================================", this.bookCommdata)
      console.log("data", this.bookCommdata)
    });

  }

  total_remaining_amt = 0;
  total_val = 0;
  value = 0;
  newvalue = 0;

  calcamount(event, book) {
    debugger
    let val = event.target.value;
    if (this.newvalue == 0) {
      this.newvalue = val;
    } else {
      this.newvalue += val
    }

    this.newvalue = val;
    this.total_val = 0;
    // console.log({ book });
    let remaining_amt =
      parseInt(book['rep_commission_amt']) -
      (parseInt(book['rcvd_amt']) + parseInt(val));
    this.total_remaining_amt = 0;


    let updatedBook = { ...book }; // Clone the book object to avoid modifying the original reference
    updatedBook['rcvd_amt'] = val;
    updatedBook['remaining_amt'] = remaining_amt;
    updatedBook['isDisabled'] = remaining_amt === 0 || remaining_amt === 0.00;

    // Track changes in `updatedCommBooks`
    let index = this.updatedCommBooks.findIndex(b => b.bookid === book.bookid);
    if (index !== -1) {
      this.updatedCommBooks[index] = updatedBook; // Update existing entry
    } else {
      this.updatedCommBooks.push(updatedBook); // Add new entry
    }

    for (let index = 0; index < Object.keys(this.bookCommdata).length; index++) {
      if (this.bookCommdata[index]['bookid'] == book['bookid']) {
        this.bookCommdata[index]['rcvd_amt'] = parseInt(val);
        this.value = this.value + parseInt(val);
        this.bookCommdata[index]['comm_remaining_amt'] = remaining_amt;
        // Disable input if remaining amount is 0
        this.bookCommdata[index]['isDisabled'] = remaining_amt === 0 || remaining_amt === 0.00; // ✅ Ensure both 0 and 0.00 are considered

        this.selectedAmt = this.selectedAmt + Number(this.newvalue);
        this.balanceAmt = this.crdtvAmt - this.selectedAmt;

      }
      debugger
      this.total_val =
        this.total_val + parseInt(this.bookCommdata[index]['rcvd_amt']);
      this.total_remaining_amt =
        this.total_remaining_amt +
        parseInt(this.bookCommdata[index]['comm_remaining_amt']);
    }
    console.log("bookCommdata", this.bookCommdata)
  }

calcCommission(book: any, event?: any): void {
  // 1. Read percentage from input OR fallback to existing book.commper
  let percentage = event?.target?.value
    ? parseFloat(event.target.value)
    : parseFloat(book.commper);

  // 2. If input invalid, fallback to existing DB/API value
  if (isNaN(percentage) || percentage < 0) {
    percentage = parseFloat(book.commper) || 0;
  }

  // 3. Round to 2 decimals
  percentage = Math.round(percentage * 100) / 100;

  // 4. Store normalized percentage
  book.commper = percentage;

  // 5. Update the UI input (removes trailing zeros)
  if (event?.target) {
    event.target.value = percentage.toString();
  }

  // 6. Calculate commission amount
  const receivedAmount = parseFloat(book.total_amount) || 0;

  let commissionAmount = (receivedAmount * percentage) / 100;
  commissionAmount = Math.round(commissionAmount * 100) / 100;

  book.rep_commission_amt = commissionAmount;

  // 7. Remaining commission after already received
  const alreadyReceived = parseFloat(book.rcvd_amt) || 0;
  let remainingAmount = commissionAmount - alreadyReceived;

  book.comm_remaining_amt = Math.max(
    0,
    Math.round(remainingAmount * 100) / 100
  );

  // 8. Disable if no remaining amount
  book.isDisabled = book.comm_remaining_amt <= 0;

  // 9. Recalculate totals
  this.recalculateTotals();
}


// Helper method to normalize percentage on blur
normalizePercentage(book: any, event: any): void {
  let percentage = parseFloat(event.target.value);
  
  if (isNaN(percentage) || percentage < 0) {
    percentage = 0;
  }
  
  // Round to 2 decimal places
  percentage = Math.round(percentage * 100) / 100;
  
  // Update the value as float
  book.commper = percentage;
  
  // Remove trailing zeros (25.00 becomes "25", 25.10 becomes "25.1")
  event.target.value = percentage.toString();
  
  // Recalculate commission
  this.calcCommission(book, event);
}

// Method to recalculate total values and remaining amounts
recalculateTotals(): void {
  this.total_val = 0;
  this.total_remaining_amt = 0;

  this.bookCommdata.forEach(book => {
    const rcvdAmt = parseFloat(book['rcvd_amt']) || 0;
    const remainingAmt = parseFloat(book['comm_remaining_amt']) || 0;
    
    this.total_val += rcvdAmt;
    this.total_remaining_amt += remainingAmt;
  });
  
  // Round totals to 2 decimal places
  this.total_val = Math.round(this.total_val * 100) / 100;
  this.total_remaining_amt = Math.round(this.total_remaining_amt * 100) / 100;
}
  save() {
    console.log(this.value);

    this.dialogRef.close({
      data: this.updatedCommBooks,
      selecetdAmt: this.selectedAmt,
      remaining_amt: this.total_remaining_amt,
      value: this.value,
      balanceAmt: this.balanceAmt,

      id: this.bookCommreceipt['id'],
    });
  }
}
